<template>
  <el-container  type="flex" class="main_container">
    <base-header>
      交易额总量：{{this.content.income_total}}元
    </base-header>
    <el-main>
      <div class="chart_box">
        <base-chart
          chartUrl="income_daily"
          chartText="日交易额"
          want="income"
          type="money"
          :total="total_day"
          :is-pie="true"
        ></base-chart>
        <base-chart
          chartUrl="income_monthly"
          chartText="月交易额"
          want="income"
          type="money"
          :total="total_month"
          :is-pie="true"
        ></base-chart>
        <base-chart
          chartUrl="income_incr_rate_daily"
          chartText="交易额日增长率"
          want="income_incr_rate"
          type="percent"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="income_incr_rate_monthly"
          chartText="交易额月增长率"
          want="income_incr_rate"
          type="percent"
          :total="total_month"
        ></base-chart>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import chartMixin from '../../../../mixins/chart'

export default {
  name: 'DBIncome',
  mixins: [chartMixin]
}
</script>
